module.exports = __webpack_public_path__ + "img/fashion_19.3bf9c5cd.jpg";